<template>
  <div :class="['result-filter-container']">
    <p class="txt">
      YOU HAVE EARNED YOUR
      <br />PLACE IN THIS CROWDED WORLD
    </p>
    <button id="getFilterBtn" @click="handleUnlockClicked">UNLOCK LENS</button>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
export default {
  setup(props, { emit }) {
    const handleUnlockClicked = () => {
      //   console.log("handleUnlockFilterClicked");
      emit("unlockLensClick");
    };

    return {
      handleUnlockClicked,
    };
  },
};
</script>

<style scoped lang="scss">
.txt {
  font-size: 1.2rem;
}
#getFilterBtn {
  margin-bottom: 20px;
  background: transparent;
  background-image: url("~@/assets/images/submit_btn_bg.png");
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  border: none;
  color: white;
  // width: 80%;
  padding: 15px 30px 15px 30px;
  font-size: 1.3rem;
}
</style>